import { useFieldContext } from "@/core/form/hooks/useFormContext";
import { tKey, type I18nKey } from "@/core/i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/modules/shadcn/ui/select";
import { EvalLimitItemOperatorEnum } from "@repo/schema";
import { useTranslation } from "react-i18next";

const operatorLabel = {
  [EvalLimitItemOperatorEnum.AND]: tKey("evaluation:limitForm.operator.AND"),
  [EvalLimitItemOperatorEnum.OR]: tKey("evaluation:limitForm.operator.OR"),
} satisfies Record<EvalLimitItemOperatorEnum, I18nKey<"evaluation">>;

/** The trigger shows the operator in capitals, as the logic builder does. */
const operatorValue = {
  [EvalLimitItemOperatorEnum.AND]: tKey("evaluation:logicOperator.AND"),
  [EvalLimitItemOperatorEnum.OR]: tKey("evaluation:logicOperator.OR"),
} satisfies Record<EvalLimitItemOperatorEnum, I18nKey<"evaluation">>;

const operatorOptions = Object.values(EvalLimitItemOperatorEnum);

export function LogicalOperatorSelect() {
  const { t } = useTranslation(["evaluation", "common"]);
  const field = useFieldContext<EvalLimitItemOperatorEnum>();
  const value = field.state.value ?? EvalLimitItemOperatorEnum.AND;

  return (
    <div className="flex items-center gap-1.5">
      <span className="text-xs text-muted-foreground">
        {t("limitForm.logicalOperator")}
      </span>
      <Select
        value={value}
        onValueChange={(v) => field.handleChange(v as EvalLimitItemOperatorEnum)}
      >
        <SelectTrigger
          size="sm"
          className="h-auto w-auto gap-1 border-0 bg-transparent p-0 text-xs font-medium shadow-none focus-visible:border-0 focus-visible:bg-transparent focus-visible:ring-0"
        >
          <SelectValue>{t(operatorValue[value])}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {operatorOptions.map((op) => (
            <SelectItem key={op} value={op}>
              {t(operatorLabel[op])}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
